export enum OrderStatus {
  /**
   * Draft created in backstage and not yet marked as submitted.
   */
  NotSubmitted = 'not_submitted',
  /**
   * Draft is being validated in backstage.
   */
  Submitting = 'submitting',
  /**
   * Draft is validated and ready to be submitted.
   */
  ReadyToSubmit = 'ready_to_submit',
  /**
   * Draft is in process to be submitted.
   */
  InSubmission = 'in_submission',
  /**
   * Draft created in backstage and marked as submitted.
   */
  Submitted = 'submitted',
  /**
   * Draft marked to be picked to be retried from backstage jobs.
   */
  Retry = 'retry',
  /**
   * Status to mark an order was correctly sent to dynamics but "lost" by the dynamics importer. Normally happens when dynamics is upgrading.
   */
  Missing = 'missing',
  /**
   * When an order was attempted to be retried but the retry fails.
   */
  Error = 'error',
  /**
   * When the max amount of retries was reached and order is still not able to be created.
   */
  MaxRetryAttemptsError = 'error_max_retry_attempts',
  /**
   * @deprecated
   * In progress was splitted as Submitted & Submitting, please use those.
   */
  InProgress = 'in progress',
  /**
   * The Sales order was created in dynamics, and may be also confirmed.
   */
  CreatedInDynamics = 'created_in_dynamics',
  /**
   * The Sales order was confirmed in dynamics.
   */
  ConfirmedInDynamics = 'confirmed_in_dynamics',
  /**
   * The Sales order was confirmed in dynamics.
   */
  Open = 'open',
  /**
   * The Sales order was confirmed in dynamics.
   */
  Backorder = 'backorder',
  /**
   * The Sales order was confirmed in dynamics but is on hold.
   */
  Hold = 'hold',
  /**
   * The existing order in dynamics is marked to be updated in dynamics.
   */
  UpdateInProgress = 'update in progress',
  /**
   * Some of the parcels of an order were already delivered
   */
  PartiallyShipped = 'partially shipped',
  /**
   * The was already delivered
   */
  Delivered = 'delivered',
  /**
   * The order was partially invoiced
   */
  PartiallyInvoiced = 'partially invoiced',
  /**
   * The order was fully invoiced
   */
  Invoiced = 'invoiced',
  /**
   * The order is closed in dynamics and no more changes are allowed
   */
  Closed = 'closed',
  /**
   * The order is marked as deleted in dynamics and no more changes are allowed
   */
  Deleted = 'deleted',
}
